import { connectCustom } from "@client/lib/misc";
import { makeEntityChildrenIdsSelector } from "@client/selectors";
import { type EntityRef } from "@client/types";
import { type ViewerAppState } from "@client/viewer/types";
import Component, { type EntityContainerMapProps } from "./component";

export type EntityContainerProps = EntityRef & {
  style?: React.CSSProperties;
  viewonly?: boolean;
};

const makeMapStateToProps = () => {
  const childrenIdsSelector = makeEntityChildrenIdsSelector();

  return (state: ViewerAppState, props: EntityContainerProps): EntityContainerMapProps => {
    return {
      ...props,
      itemsIds: childrenIdsSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
